module.exports = __webpack_public_path__ + "img/symbol_3.12690aa6.png";